import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {DecisionGridChangeLogDetailModel} from '../Models/decision-grid-change-log-detail-model';
import {DecisionGridChangeLogSummaryModel} from '../Models/decision-grid-change-log-summary-model';
import {tap} from 'rxjs/operators';
import { CriminalGridAcceptanceDisclaimer } from '../Models/criminalGridDisclaimerAcceptance';


@Injectable({
  providedIn: 'root'
})
export class DecisionGridChangeLogService {

  public details$ = new BehaviorSubject<DecisionGridChangeLogDetailModel[]>([]);
  public summary$ = new BehaviorSubject<DecisionGridChangeLogSummaryModel[]>([]);

  private loadingDetailsSubject = new BehaviorSubject<boolean>(false);
  public loadingDetails$ = this.loadingDetailsSubject.asObservable();

  private loadingSummarySubject = new BehaviorSubject<boolean>(false);
  public loadingSummary$ = this.loadingSummarySubject.asObservable();

  constructor(private http: HttpClient) {
  }

  public getDecisionGridChangeLogDetails(clientId: number, form: any): Observable<DecisionGridChangeLogDetailModel[]> {

    this.loadingDetailsSubject.next(true);

    return this.http.post<DecisionGridChangeLogDetailModel[]>(`${environment.baseURl}/api/decisionGrid/DecisionGridChangeLog/GetDecisionGridChangeLogDetails/${clientId}?top=25`, form)
      .pipe(tap((r: DecisionGridChangeLogDetailModel[]) => {
          this.details$.next(r);
          this.loadingDetailsSubject.next(false);
        }
      ));
  }

  public getDecisionGridChangeLogSummary(clientId: number): Observable<DecisionGridChangeLogSummaryModel[]> {

    this.loadingSummarySubject.next(true);

    return this.http.get<DecisionGridChangeLogSummaryModel[]>(`${environment.baseURl}/api/decisionGrid/DecisionGridChangeLog/GetDecisionGridChangeLogSummary/${clientId}?top=25`)
      .pipe(tap((r: DecisionGridChangeLogSummaryModel[]) => {
          this.summary$.next(r);
          this.loadingSummarySubject.next(false);
        }
      ));
  }


  public saveCrimGridDisclaimer(disc: CriminalGridAcceptanceDisclaimer) {
    return this.http.post<any>(environment.baseURl + '/api/decisionGrid/DecisionGridChangeLog/', disc);
  }

  public FetchSnapshotReportBytes(pitId: number) {
    return this.http.get(`${environment.baseURl}/api/decisionGrid/DecisionGridChangeLog/snapshot/${pitId}`, { responseType: 'blob' });
  } 
}
